import Injection = EECore.Injection;
import UpcomingUnavailabilityModel from "../entities/upcomingUnavailability/upcomingUnavailabilityModel";

@Injection.injectableClass("UpcomingUnavailabilityService")
export default class UpcomingUnavailabilityService {

  @Injection.injectableProperty("UpcomingUnavailabilityService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  constructor(httpClient: EECore.HttpClient) {
    this.httpClient = httpClient;
  }

  getUpcomingUnavailability(availabilityGroup: string): EECore.Promise<UpcomingUnavailabilityModel, string> {
    return new EECore.Promise<UpcomingUnavailabilityModel, string>((resolve, reject) => {
      const url = `/eemwpnp1/public/api/availability/upcomingUnavailability?availabilityGroup=${availabilityGroup}`;
      const request = this.httpClient.get<UpcomingUnavailabilityModel>(url, true);
      request.then((model: UpcomingUnavailabilityModel) => {
        resolve(model);
      }).catch((error: string) => {
        reject(error);
      });
    });
  }

}